import type { DatosFabricando } from "@/ts/api/API";
import { useQuery } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { Constantes } from "@/ts/constantes";
import { type BaseModalProps, BaseModal, ModalCloseCross } from "@/components/modals/BaseModal";
import { Loading } from "@/components/Loading/Loading";
import { FormImputar } from "./components/FormInputar";

interface ModalImputarFaseProps extends BaseModalProps {
	readonly idOF: number | null;
	readonly idFase: number | null;
}
export function ModalImputarFase(props: ModalImputarFaseProps) {
	const { data, isPending, error, dataUpdatedAt } = useInfoFabricando({ idOF: props.idOF, idFase: props.idFase });

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h2 className="modal-title">
					<span>Imputar Fase:</span>
					<span>OF #{props.idOF}</span>
					{Constantes.existenFases ? (
						<span>- Fase {props.idFase}</span>
					) : null}
				</h2>
				<ModalCloseCross onClick={props.close} />
			</div>

			{data ? (
				<FormImputar
					key={dataUpdatedAt}
					datos={data}
					close={props.close}
				/>
			) : null}
			{isPending ? <Loading /> : null}
			{error ? <div>Error al cargar los datos</div> : null}

		</BaseModal>
	);
}






function useInfoFabricando(params: { idOF: number | null, idFase: number | null; }) {
	return useQuery<DatosFabricando>({
		queryKey: ["getInfoFabricando", params],
		queryFn: () => {
			if (params.idOF == null || params.idFase == null) return Promise.resolve({} as DatosFabricando); // Esto no debería pasar por el enabled, pero por si acaso
			return sendAjaxRequest<DatosFabricando>("GET", "/api/v1/getInfoFabricando", params);
		},
		enabled: params.idOF != null && params.idFase != null,
	});
}
